<template>
  <div class="notfound">
    <div class="row">
      <div class="col s12 m6 l6">
        <div class="lost">404</div>
        <div class="link">You are lost please go back Home</div>
        <br />
      </div>
      <div class="col s12 m6 my">
        <img
          src="@/assets/vectors/404.svg"
          style="margin-top: 15vh"
          class="img-responsive swing"
        />
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { computed, reactive } from "vue";
import { useHead } from "@vueuse/head";
export default {
  name: "404",
  components: {},
  setup() {
    const siteData = reactive({
      title: `Barakadev | 404`,
      description: `My beautiful website`,
    });

    useHead({
      // Can be static or computed
      title: computed(() => siteData.title),
      meta: [
        {
          name: `description`,
          content: computed(() => siteData.description),
        },
      ],
    });
  },
};
</script>

<style scoped>
.notfound {
  height: 100vh;
  margin-top: 60px;
}
.link {
  font-size: 14px;
  letter-spacing: 2px;
  font-weight: 500;
  color: #3a3a3a;
  padding: 8px 8px;
  text-align: center;
}
@font-face {
  font-family: "Monoton";
  font-style: normal;
  font-weight: 400;
  src: url("../assets/fonts/Monoton-Regular.ttf");
}
.img-responsive {
  width: 100%;
  height: auto;
}

@media only screen and (max-width: 600px) {
  .my {
    display: none;
  }
}
.lost {
  font-size: 115px;
  margin-top: 20vh;
  font-weight: 500;
  text-shadow: 1px 1px 1px rgb(0, 0, 0);
  text-transform: lowercase;
  color: #333;
  text-align: center;
  font-family: "Monoton";
}

@-webkit-keyframes swinging {
  0% {
    /* -webkit-transform: (8deg); */
    -webkit-transform: translateY(20py);
  }
  50% {
    /* -webkit-transform: rotate(-4deg); */
    -webkit-transform: translateY(0px);
  }
  100% {
    /* -webkit-transform: rotate(8deg); */
    -webkit-transform: translateY(20px);
  }
}

@keyframes swinging {
  0% {
    /* -webkit-transform: (8deg); */
    -webkit-transform: translateY(20px);
  }
  50% {
    /* -webkit-transform: rotate(-4deg); */
    -webkit-transform: translateY(0px);
  }
  100% {
    /* -webkit-transform: rotate(8deg); */
    -webkit-transform: translateY(20px);
  }
}

.swing {
  -webkit-transform-origin: 50% 0;
  transform-origin: 50% 0;
  -webkit-animation: swinging 3.5s ease-in-out forwards infinite;
  animation-delay: 5s;
  animation: swinging 3.5s ease-in-out forwards infinite;
}
</style>
